import { render } from "./ResultStyle.vue?vue&type=template&id=67c21b42&scoped=true"
import script from "./ResultStyle.vue?vue&type=script&lang=js"
export * from "./ResultStyle.vue?vue&type=script&lang=js"

import "./ResultStyle.vue?vue&type=style&index=0&id=67c21b42&lang=scss&scoped=true"

import exportComponent from "/Users/konatsu/docker-static/speedo.devs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c21b42"]])

export default __exports__